import React from 'react';
import {IconProps} from "../services/IconConstants";

const SunIcon = ({size, colour, style, className}: IconProps) => {

    return (
        <svg viewBox="0 0 24 24"
             width={size}
             height={size}
             color={colour ? colour : 'var(--text)'}
             style={style}
             className={className}
             fill={"none"}>
            <path
                d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
                stroke="currentColor" stroke-width="1.5"/>
            <path
                d="M11.9955 3H12.0045M11.9961 21H12.0051M18.3588 5.63599H18.3678M5.63409 18.364H5.64307M5.63409 5.63647H5.64307M18.3582 18.3645H18.3672M20.991 12.0006H21M3 12.0006H3.00898"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}

export default SunIcon;